import { useCallback, useState } from 'react';

/**
 * ダイアログの状態管理のためのカスタムフックです。
 * @returns {Object} ダイアログの状態管理に関するメソッドを含むオブジェクト
 */
export const useDialog = () => {
  const [isOpen, setOpen] = useState(false);
  /**
   * ダイアログを開く関数です。
   * @memberof useDialog
   * @inner
   * @returns {void}
   * @example
   * handleOpen(); // ダイアログを開く
   */
  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);
  /**
   * ダイアログを閉じる関数です。
   * @memberof useDialog
   * @inner
   * @returns {void}
   * @example
   * handleClose(); // ダイアログを閉じる
   */
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  /**
   * ダイアログの状態を返すオブジェクトです。
   * @typedef {Object} DialogStatus
   * @property {boolean} isOpen - ダイアログが開いているかどうかを表すフラグ
   * @property {Function} handleOpen - ダイアログを開く関数
   * @property {Function} handleClose - ダイアログを閉じる関数
   */

  /**
   * ダイアログの状態を返す関数です。
   * @returns {DialogStatus} ダイアログの状態を表すオブジェクト
   * @example
   * const { isOpen, handleOpen, handleClose } = useDialog();
   * console.log(isOpen); // ダイアログの開閉状態を表示
   * handleOpen(); // ダイアログを開く
   * handleClose(); // ダイアログを閉じる
   */
  return { isOpen, handleOpen, handleClose };
};
